"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BonusInfo = function (_a) {
    var _b, _c;
    var onClose = _a.onClose, onCancel = _a.onCancel, bonus = _a.bonus;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var minDepositData = (_b = bonus === null || bonus === void 0 ? void 0 : bonus.conditions) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c.type === profile_api_1.BonusConditionType.MinDepositAmount; });
    var minDeposit = (_c = minDepositData === null || minDepositData === void 0 ? void 0 : minDepositData.minDeposit) === null || _c === void 0 ? void 0 : _c.find(function (d) { return d.currency === currentCurrency; });
    var minDepositAmount = minDeposit === null || minDeposit === void 0 ? void 0 : minDeposit.amount;
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "480px", height: "auto", portalNodeId: "modal", showClose: false, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusBonus }, bonus === null || bonus === void 0 ? void 0 : bonus.title),
                minDepositAmount && (react_1.default.createElement("div", { className: styles_module_scss_1.default.minDeposit },
                    t('minDepositAmount'),
                    ": ",
                    (0, apps_shared_1.getCurrencySymbol)(currentCurrency),
                    minDepositAmount))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "primary", onClick: onClose }, t('useBonus')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.cancelBonus, onClick: onCancel }, t('useAnotherBonus'))))));
};
exports.default = BonusInfo;
